import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SafeHtml } from '@angular/platform-browser';
import { CurrencySymbolPipe } from '@app/pipes/currency-symbol.pipe';
import { DecimalInputComponent } from '@app/shared/decimal-input/decimal-input.component';
import { SbFormFieldComponent } from '@app/shared/sb-lib/forms/sb-form-field.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IconComponent } from '@sb/ui';

@Component({
  selector: 'target-setting-setup',
  standalone: true,
  templateUrl: './target-setting-setup.component.html',
  imports: [
    TranslateModule,
    DecimalInputComponent,
    SbFormFieldComponent,
    ReactiveFormsModule,
    IconComponent,
    CurrencySymbolPipe,
  ],
})
export class TargetSettingSetupComponent implements AfterViewInit {
  @Input()
  public description: string;
  @Input()
  public explanation: string;
  @Input()
  public fieldLabel: string | SafeHtml;
  @Input()
  public placeholder = this.translate.instant('Enter target value');
  @Input()
  public prefix: 'currency' | 'percentage';
  @Input()
  public control: FormControl<string>;

  public constructor(
    private translate: TranslateService,
    private elementRef: ElementRef,
  ) {}

  public ngAfterViewInit(): void {
    this.focusFirstInput();
  }

  private focusFirstInput() {
    const input = this.elementRef.nativeElement.querySelector('input');
    if (input) {
      input.focus();
    }
  }
}
